import { rgba } from 'polished';
import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import {
	fontFamily,
	FontSize,
	fontSize,
	fontWeight,
	FontWeight,
	FontWeights,
	lineHeight,
} from '../../utils/typography';
import { Wrapper as LoaderWrapper } from '../Loader/styles';
import { PaletteColor } from '../ThemeProvider';

export const Wrapper = styled.button<{
	disabled?: boolean;
	$isLoading?: boolean;
	$size?: FontSize;
	$textColor: PaletteColor;
	$hideUnderline: boolean;
	$weight?: FontWeight;
}>`
	background: transparent;
	text-decoration: ${p => (p.$hideUnderline ? 'none' : 'underline')};
	border: none;
	padding: 0;
	margin: 0;
	border: none;
	color: ${props =>
		rgba(props.disabled ? '#C6C6C6' : palette(props.$textColor)(props), props.$isLoading ? 0.25 : 1)};
	display: inline-block;
	${fontFamily};
	${p => (p.$size ? fontSize(p.$size) : '')};
	${p => (p.$size ? lineHeight(p.$size) : '')};
	${p => fontWeight(p.$weight ?? FontWeights.Medium)};
	position: relative;
	transition: ${theme('animation.transition')};
	z-index: 0;
	cursor: ${props => (props.disabled ? 'initial' : 'pointer')};

	${LoaderWrapper} {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translateX(-50%) translateY(-50%);
		width: 100%;
	}
`;
